import { z } from "zod";

// ── Password policy (single source of truth FE) ─────────────────────────────
// Mirror backend strongPasswordSchema (backend/src/infra/password.ts).
// WRITE path (register / reset / change-password) → strongPasswordSchema.
// LOGIN path tetap lenient (lihat login-schema.ts) — wajib menerima password
// user lama (legacy); mengetatkannya = lockout (BE tolak zod sebelum bcrypt).
export const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
const PASSWORD_POLICY_MSG = "Password minimal 8 karakter, 1 huruf kapital, 1 angka";

export const strongPasswordSchema = z.string().regex(PASSWORD_REGEX, PASSWORD_POLICY_MSG);
